"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FontLinks;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function FontLinks() {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("link", {
    href: "https://fonts.googleapis.com/css2?family=Montserrat:wght@200..900&family=Roboto+Flex:wght@200..900&display=swap",
    rel: "stylesheet"
  }), /*#__PURE__*/_react.default.createElement("link", {
    href: "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css",
    rel: "stylesheet"
  }));
}